import { Paragraph } from '@limitless-minds/ui-text'
import { Stack, styled, useTheme } from '@mui/material'
import React from 'react'

const StyledHeaderWrapper = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',
  },
}))

const StyledHeader = styled('h1')(({ theme }) => ({
  color: theme.palette.role.onSurfaceMuted,
  textAlign: 'center',
  fontFamily: 'Lato',
  fontSize: '0.90256rem',
  fontStyle: 'italic',
  fontWeight: 400,
  lineHeight: '1.0315rem',
  letterSpacing: '0.09025rem',
  margin: '0 0 0.5rem 0',
}))

const StyledDescription = styled(Paragraph)(({ theme }) => ({
  textAlign: 'center',
  whiteSpace: 'pre-line',
  [theme.breakpoints.up('lg')]: {
    textAlign: 'left',
  },
}))

const StyledH2 = styled('h2')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('lg')]: {
    textAlign: 'left',
  },
}))

interface HeaderWrapperProps {
  subtitle?: string
  title: React.ReactNode
  description?: React.ReactNode
}

const HeaderWrapper: React.FC<HeaderWrapperProps> = ({ subtitle, title, description }) => {
  const theme = useTheme()
  return (
    <StyledHeaderWrapper>
      {subtitle && <StyledHeader>{subtitle}</StyledHeader>}
      <StyledH2 style={{ marginBottom: description ? '0.75rem' : '0' }}>{title}</StyledH2>
      {description && (
        <StyledDescription variant='p16' color={theme.palette.role.onSurfaceVariant}>
          {description}
        </StyledDescription>
      )}
      <img
        src={'/images/color-bar.jpg'}
        width={250}
        height={8}
        alt={''}
        style={{ marginTop: '2rem', width: '100%', maxWidth: '15.625rem' }}
      />
    </StyledHeaderWrapper>
  )
}

export default HeaderWrapper
